<script>
export default {
  props: {
    color: {
      type: String,
      default: 'primary',
    },
  },
}
</script>

<template>
  <div
    class="d-flex v-application"
    style="
        bottom: 20px;
        position: fixed;
        z-index: 3;
      "
  >
    <v-card class="elevation-3 d-flex" :color="color">
      <slot />
    </v-card>
  </div>
</template>
